<template>
    <div>
        <a-button class="top_btn" type="primary" @click="addVersion()"
                  v-has="'btn_add'"> 添加版本
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()"> 排序</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
            <span slot="list_order" slot-scope="text, record">
        <a-input v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
                <a-switch @click="onChange(record)"
                          :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
            </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_role','btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
                <a @click="(record) => { visibleJurisdiction = true; titleForm=`${text.name}-权限设置`;jurisdictionId=text.id ;  }"
                   v-has="'btn_role'">权限设置<a-divider type="vertical"/></a>
                <a @click="(record)=>{visibleForm = true; titleForm='修改版本'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider
                    type="vertical"/></a>
                <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="confirm(record)"
                    @cancel="()=>{}">
                    <a v-has="'btn_delete'">删除</a>
                </a-popconfirm>
            </span>
        </a-table>
        <VersionForm :visible="visibleForm" :title="titleForm" :editId="editId"
                     ref="addVersionRef"
                     @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList(pagination.current)}  "/>
        <JurisdictionForm :visibleJurisdiction="visibleJurisdiction" :title="titleForm" :jurisdictionId="jurisdictionId"
                          @changVisible=" () => { this.visibleJurisdiction = false;this.jurisdictionId='';  this.getList(pagination.current)}  "/>
    </div>
</template>

<script>
import API from "./api";
import VersionForm from "./components/versionForm"
import JurisdictionForm from "./components/jurisdictionForm"
import {changStatus, removeById} from "@/utils/utils"
import {orderList} from "../../../utils/utils";

const columns = [{
    title: "排序",
    dataIndex: "list_order",
    key: "list_order",
    width: "100px",
    scopedSlots: {customRender: "list_order"}
},
    {
        title: "ID",
        dataIndex: "id",
        width: "10%",
        ellipsis: true,
        key: "id"
    },
    {
        title: "版本名称",
        dataIndex: "name",
        width: "15%",
        ellipsis: true,
        key: "name"
    },
    {
        title: "描述",
        dataIndex: "abstract",
        ellipsis: true,
        key: "abstract"
    },
    {
        title: "分组",
        dataIndex: "group_name",
        width: "10%",
        ellipsis: true,
        key: "group_name"
    },
    {
        title: "可视化版本",
        dataIndex: "ksh_panel_role_name",
        ellipsis: true,
        key: "ksh_panel_role_name"
    },
    {
        title: "状态",
        key: "status",
        width: "150px",
        dataIndex: "status",
        scopedSlots: {customRender: "status"}
    },
    {
        title: "操作",
        key: "action",
        width: "200px",
        scopedSlots: {customRender: "action"}
    }
];
export default {
    name: 'index',
    data() {
        return {
            disabledStatus: false,
            pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
            },
            visibleForm: false,
            titleForm: "",
            loading: true,
            editId: null,
            jurisdictionId: null,
            visibleJurisdiction: false,
            data: [],
            columns,
        }
    },
    created() {
        this.$store.state.adminleftnavnum = "/UserBackground/VersionManagement"; //设置左侧导航2-2 active
        this.$nextTick(() => {
            this.disabledStatus = this.$_has('btn_status')
        });
    },
    components: {VersionForm, JurisdictionForm},
    methods: {
        addVersion() {
            this.visibleForm = true;
            this.titleForm = '添加版本';
            this.$refs.addVersionRef?.open()
        },
        getList(page) {
            API.versionManagement.GET_LIST(page || 1).then(res => {
                this.pagination.total = res.data.data.total
                this.pagination.pageSize = res.data.data.per_page
                this.pagination.current = res.data.data.current_page
                this.data = res.data.data.data
                this.loading = false
            })
        },
        onChange(row) {
            let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
            changStatus(API.versionManagement.CHANG_STATUS, [Json]).then(res => {
                if (res == true) {
                    this.getList(this.pagination.current)
                }
            })
        },
        confirm(row) {
            removeById(API.versionManagement.DELE, [row.id]).then(res => {
                if (res == true) {
                    this.getList()
                }
            })
        }, listOrder() {
            let list_orders = []
            let sortListOrder = {id: "", list_order: ""}
            for (let i = 0; i < this.data.length; i++) {
                sortListOrder.id = this.data[i].id
                sortListOrder.list_order = this.data[i].list_order
                list_orders.push(sortListOrder)
                sortListOrder = {}
            }
            console.log("list_orders", list_orders)
            orderList(API.versionManagement.LIST_ORDER, list_orders).then(res => {
                if (res == true) {
                    this.getList()
                }
            })
        },
    },

    mounted() {
        this.getList()
    }
}
</script>
